import React, {createContext, useContext} from "react";

export const DataContext = createContext();
export const ExtraDataContext = createContext();

export const useElasticData = () => useContext(DataContext);
export const useExtraData = () => useContext(ExtraDataContext);